module.exports = __webpack_public_path__ + "static/media/fetch-BG.39a9a5cd.svg";